/**
 * Colour swatches for the Landing · Product pair section.
 * Clicking a swatch swaps that card's primary image to the selected colour's image.
 * Delegated + idempotent so it survives Shopify section re-renders in the editor.
 */
if (!window.__mlpSwatchBound) {
  window.__mlpSwatchBound = true;
  document.addEventListener('click', function (e) {
    const sw = e.target.closest('.mlp-pp__swatch');
    if (!sw) return;
    const card = sw.closest('.mlp-pp__card');
    if (!card) return;
    const img = card.querySelector('.mlp-pp__frame > img');
    if (img && sw.dataset.src) {
      if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
      img.src = sw.dataset.src;
    }
    card.querySelectorAll('.mlp-pp__swatch').forEach(function (b) { b.classList.remove('is-active'); });
    sw.classList.add('is-active');
  });
}
